import { ListItemProps } from 'components/List/ListItem';
import { checkCircle } from 'icons/default';

export const howItWorksItemsBuy: ListItemProps[] = [
  {
    label: 'Det mest omfattande skyddet för en begagnad bil, MC och husbil',
    symbol: checkCircle,
  },
  {
    label: 'Gäller i hela Europa',
    symbol: checkCircle,
  },
  {
    label: 'Obegränsad årlig körsträcka',
    symbol: checkCircle,
  },
  {
    label: 'Kan tecknas på bilar upp till 9 år',
    symbol: checkCircle,
  },
];
